var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 144,
    viewBox: "0 0 93 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.4886 139.631L20.4972 139.634L20.5058 139.636C27.0997 141.548 34.1075 142.5 41.5221 142.5C50.8784 142.5 59.3009 140.654 66.7563 136.926C74.216 133.196 80.1016 127.885 84.3789 121.001C88.7411 114.021 90.8917 105.774 90.8917 96.3217C90.8917 87.4711 89.0411 79.6684 85.2868 72.9629C81.5339 66.1951 76.1654 60.9316 69.2143 57.1888C62.2492 53.4383 54.0324 51.5939 44.6167 51.5939C41.0163 51.5939 37.5407 51.7903 34.1905 52.1844C34.1512 52.189 34.1119 52.1937 34.0725 52.1984L37.4342 24.7116H82.2355H83.6586L83.7334 23.2905L84.7971 3.07884L84.8802 1.5H83.2992H19.473H18.1407L17.9835 2.82297L9.57005 73.612L9.31713 75.74L11.4031 75.2492C15.7429 74.2281 20.0154 73.4311 24.2209 72.8577L24.2303 72.8564L24.2396 72.855C28.4815 72.2219 32.888 71.9044 37.4604 71.9044C46.5057 71.9044 53.4785 74.1006 58.5492 78.3261L58.5573 78.3329C63.5601 82.4422 66.1328 88.3608 66.1328 96.3217C66.1328 103.505 63.8174 109.072 59.2784 113.195C54.7149 117.276 48.5908 119.385 40.7484 119.385C34.6459 119.385 29.1518 118.473 24.2482 116.674C19.2972 114.833 14.471 112.579 9.76914 109.91L8.06893 108.945L7.577 110.837L2.54827 130.178L2.27522 131.228L3.18719 131.816C8.21961 135.061 13.9913 137.662 20.4886 139.631Z",
    stroke: "#767676",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.aebd6c493bae22fed479fafba73c1448.svg";
export { ForwardRef as ReactComponent };